import { Injectable } from '@angular/core';
import { SharedModule } from '../shared.module';
import { Window } from 'ascedia-design-system/lib/models/window.interface';
import { Breakpoint } from 'ascedia-design-system/lib/models/breakpoint.enum';

const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class UtilityService {

    public window: Window = { width: 0, height: 0};
	public isMobile: boolean = false;

    /**
	 * Get window dimensions
	 * @param event 
	*/
	public getWindowDims(event:any = null) {
		if(event) {
			this.window.width = event.target.innerWidth;
			this.window.height = event.target.innerHeight;
		} else {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		}
		//if(_log) console.log('window:', this.window);
	}


	public getIsMobile() {
		this.getWindowDims();
		if(this.window.width < Breakpoint.lg) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
		return this.isMobile;
	}



    public makeStringWebsafe(s: string){
		if(_log) console.log('makeStringWebsafe.s:', s);
		if(!s || s == undefined) return s;
		const newString = s.replace(/[^a-z0-9]/gi, '-').toLowerCase();
		if(_log) console.log('makeStringWebsafe.newString:', newString);
		return newString;
	}

	public undoMakeStringWebsafe(s: string){
		let newString = s.replace(/-/gi, ' ');
		newString = this.capitalizeWords(newString);
		if(_log) console.log('undoMakeStringWebsafe.s:', s, ' -> ', newString);
		return newString;
	}

	//capitalize only the first letter of the string. 
	public capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	//capitalize all words of a string. 
	public capitalizeWords(string) {
		return string.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
	};

}